import React, { useEffect } from "react";
import { connect } from "react-redux";
import OrdersHeader from "./widgets/header";
import OrdersDatagrid from "./widgets/datagrid";
import { Grid, TextField } from "@mui/material";

const OrdersListPage = (props) => {
    useEffect(() => {}, []);

    return (
        <div>
            <OrdersHeader />
            <OrdersDatagrid />
        </div>
    );
};

const mapStateToProps = (state) => ({ tickets: state.tickets });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersListPage);
